export default __webpack_public_path__ + "static/media/info_photo.199242cf.svg";